import RoxBrowser from 'rox-browser'

const flags = {
  canSeeUiRebrand: new RoxBrowser.Flag(),
  canSeeAuctionPackageMenu: new RoxBrowser.Flag(),
  canSeeDemographics: new RoxBrowser.Flag(),
  cityZoomBreakpoint: new RoxBrowser.Flag(),
  postalCodeZoomBreakpoint: new RoxBrowser.Flag(),
  audienceCampaignMarketSwitch: new RoxBrowser.Flag(),
  canSeeNewAuctionPackageCpmFee: new RoxBrowser.Flag()
}

export default flags
